// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import CaptchaInfo from './view'

export default function CaptchaInfoFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/CaptchaInfo">
      <CaptchaInfo {...props}>
        {children}
      </CaptchaInfo>
    </Flow>
  )
}
